import React, { memo } from 'react';

import { Box, Tooltip } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import {
  LabelBorderStyle,
  LabelSize,
  LabelVariant,
} from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { TITLE_PORTAL_SOURCE_LABEL } from 'constants/documents';

import useDocumentUploaderName from '../../../../hooks/useDocumentUploaderName';
import { DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS } from '../../../../LoanApplicationDocuments.constants';
import {
  documentItemTagLabelStyles,
  documentItemTagWrapperStyles,
} from '../DocumentItemTag.styles';

import { DocumentUploadSourceTagTestIds } from './DocumentUploadSourceTag.testIds';
import { getTitlePortalTooltip } from './DocumentUploadSourceTag.utils';

const DocumentUploadSourceTag = ({ documentId, companyId = null, uploadedByUserId = null }) => {
  const uploaderName = useDocumentUploaderName({
    companyId,
    userId: uploadedByUserId,
    isEnabled: true,
  });

  const tooltipTitle = getTitlePortalTooltip(uploaderName);

  return (
    <Tooltip PopperProps={DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS} title={tooltipTitle}>
      <Box
        aria-label={tooltipTitle}
        component="span"
        data-testid={DocumentUploadSourceTagTestIds.getTagId(documentId)}
        role="img"
        sx={documentItemTagWrapperStyles}
      >
        <LabelCDS
          shrinkable
          withBorder
          borderStyle={LabelBorderStyle.SOLID}
          size={LabelSize.S}
          title={
            <Box component="span" sx={documentItemTagLabelStyles}>
              {TITLE_PORTAL_SOURCE_LABEL}
            </Box>
          }
          variant={LabelVariant.PURPLE}
        />
      </Box>
    </Tooltip>
  );
};

DocumentUploadSourceTag.propTypes = {
  documentId: PropTypes.string.isRequired,
  companyId: PropTypes.string,
  uploadedByUserId: PropTypes.string,
};

export default memo(DocumentUploadSourceTag);
